import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { StoreThunkAction, StoreThunkDispatch } from 'store/state'
import { LocationInfo } from 'shared'
import { V1 } from './net'

export function searchInstagramLocation(query: string): StoreThunkAction<Observable<LocationInfo[]>> {
  return (dispatch: StoreThunkDispatch) => {
    return (dispatch(V1.searchLocations(query)))
      .pipe(map((response: any) => {
        const locations: Array<LocationInfo> = []
        response.feeds.facebook.forEach((feed: any) => {
          locations.push({
            id: feed.id.toString(),
            name: feed.name,
            city: feed.location?.city || '',
            country: feed.location?.country || '',
            imageUrl: feed.profilePicture
          })
        })
        return locations
      }))
  }
}
